import Vue from 'vue'
import VueRouter from 'vue-router'

import main from '../views/main.vue'
import detail from '../views/detail.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: main
  },
  {
    path: '/detail/:firstId',
    name: 'Detail1',
    component: detail
  },
  /** 二级菜单文章列表 */
  {
    path: '/detail/:firstId/:secondId',
    name: 'SecondList',
    component: detail
  },
  /** 三级菜单文章列表 */
  {
    path: '/detail/:firstId/:secondId/:thirdId',
    name: 'ThirdList',
    component: detail
  },
  /** 三级菜单单个文章 */
  {
    path: '/detail/:firstId/:secondId/:thirdId/:articleId',
    name: 'Article',
    component: detail
  }
]

const router = new VueRouter({
  routes
})

export default router
